import axios from 'axios';
import AuthService from 'src/shared/api/auth/AuthService';
import TokenService from 'src/shared/api/token/TokenService';
import { AUTH_URL } from 'src/shared/config';

export const ApiAuth = axios.create({
  baseURL: AUTH_URL,
  withCredentials: true,
});

ApiAuth.interceptors.request.use(
  config => {
    const accessToken = TokenService.getAccessToken();
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

ApiAuth.interceptors.response.use(
  res => {
    return res;
  },
  async err => {
    const originalConfig = err.config;
    if (err?.response?.status === 401 && originalConfig?.url?.includes('/refresh')) {
      TokenService.removeTokens();
    }

    if (!originalConfig?.url?.includes('/login') && err.response) {
      if (err.response.status === 401 && !originalConfig?._retry && !originalConfig?.url?.includes('/refresh')) {
        originalConfig._retry = true;

        try {
          const { data } = await AuthService.refresh();

          TokenService.setTokens(data);
          return ApiAuth(originalConfig);
        } catch (_error) {
          TokenService.removeTokens();
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  },
);
